const scrollNav = $('.js-scrollNav');

scrollNav.onePageNav({
	currentClass: 'is_active',
	changeHash: false,
	scrollSpeed: 1300,
	scrollThreshold: 0.5,
	filter: '',
	easing: 'swing',
	offsetScroll: 150,
	scrollChange: function($currentListItem) {
		const index = $currentListItem.index();

		$('li', scrollNav)
			.eq(index)
			.addClass('is_active')
			.siblings()
			.removeClass('is_active');

		scrollToActiveElem();
	},
	end: function($currentListItem) {
		scrollToActiveElem();
	}
});

function scrollToActiveElem() {
	if ($(window).width() < 1025) {
		// для скролла к элементу в адаптиве
		let itemOuterWidth = $('.js-scrollNav .is_active').outerWidth(); // узнаем ширину текущего элемента (width + padding)
		let itemOffsetLeft = $('.js-scrollNav .is_active').offset().left; // узнаем значение отступа слева в контейнере у текущего элемента
		let containerScrollLeft = $('.js-sticky').scrollLeft(); // узнаем текущее значение скролла
		let containerOuterWidth = $('.js-sticky').outerWidth(); // узнаем ширину контейнера (width + padding)
		let positionCetner = (containerOuterWidth / 2 - itemOuterWidth / 2); // рассчитываем позицию центра
		let scrollLeftUpd = containerScrollLeft + itemOffsetLeft - positionCetner; // рассчитываем положение скролла относительно разницы отступа элемента и центра контейнера

		$('.js-sticky').animate({
			scrollLeft: scrollLeftUpd
		}, 300);
	}
}

if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
	$('body').addClass('adaptive');
}